import { render } from "./UitvaartView.vue?vue&type=template&id=93b2a528"
import script from "./UitvaartView.vue?vue&type=script&lang=js"
export * from "./UitvaartView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__